export const LEAVE_PAGE_DESCRIPTION =
  'Are you sure you want to cancel Edit Client Allocation"? All the changes will be discarded.';

export const EDIT_PAST_ALLOCATION_DESCRIPTION =
  'Caution. You are modifying a past date. Are you sure you want to proceed?';

export const MAX_MEMO_LENGTH = 500;
